import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/LoginPage';
import ChatPage from '@/pages/ChatPage';
import IntegrationsPage from './pages/IntegrationsPage';

function App() {
    return (
        <div className='font-default antialiased'>
            <Routes>
                <Route path='/' element={<HomePage />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path='/chat' element={<ChatPage />} />
                <Route path='/integrations' element={<IntegrationsPage />} />
                <Route path='*' element={<Navigate to='/' replace />} />
            </Routes>
        </div>
    );
}

export default App;
